const baseUrl = "https://roshanaale.com/";
const version = "/v1/";
const prefix = "api";

const apiUrl = baseUrl + prefix + version;
export { apiUrl };
